// Preço da assinatura (decidido pelo titular em 11/10/2026; valores em
// config.js): por caminhão com placa ativa, sem mínimo. Os 2 primeiros
// caminhões pagam o preço cheio e, do 3º em diante, o preço do adicional. No
// anual, paga 11 meses. O preço de lançamento tem a mesma estrutura, com
// preços menores.
import { LANCAMENTO, MESES_PAGOS_NO_ANO, PRECO_CAMINHAO, PRECO_CAMINHAO_ADICIONAL } from '../config.js';
import { dinheiro } from './formato.js';

const centavos = (valor) => Math.round(valor * 100) / 100;
const tabela = (lancamento) => (lancamento ? [LANCAMENTO.preco, LANCAMENTO.adicional] : [PRECO_CAMINHAO, PRECO_CAMINHAO_ADICIONAL]);

// Quanto a empresa paga por mês com tantos caminhões.
export function mensalidade(caminhoes, { lancamento = false } = {}) {
  const n = Math.max(0, Math.floor(Number(caminhoes) || 0));
  const [primeiros, adicional] = tabela(lancamento);
  return centavos(Math.min(n, 2) * primeiros + Math.max(0, n - 2) * adicional);
}

// No anual, paga 11 meses.
export function anuidade(caminhoes, opcoes = {}) {
  return centavos(mensalidade(caminhoes, opcoes) * MESES_PAGOS_NO_ANO);
}

// "R$ 69,90 por mês por caminhão (do 3º caminhão em diante, R$ 59,90)"
export function precoPorMes({ lancamento = false } = {}) {
  const [primeiros, adicional] = tabela(lancamento);
  return `${dinheiro(primeiros)} por mês por caminhão (do 3º caminhão em diante, ${dinheiro(adicional)})`;
}
